import { render, staticRenderFns } from "./indexArchive.vue?vue&type=template&id=b41e3538"
import script from "./indexArchive.vue?vue&type=script&lang=js"
export * from "./indexArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports